import Postulate from './postulate'
export default function Postu() {
    return (
        <>
            <Postulate />
        </>
    )
}